import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import { avatarSizeMap } from "../../../Avatar/utils";
var calcElementsVisibleSize = function calcElementsVisibleSize(elementsSizes, map) {
  return map.reduce(function (acc, _, i) {
    return map[i] ? acc + elementsSizes[i] : acc;
  }, 0);
};
var getWidths = function getWidths(length, size) {
  var offset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : -12;
  return Array.from({
    length: length
  }).map(function (_, i) {
    return i === 0 ? avatarSizeMap[size] : avatarSizeMap[size] - offset;
  });
};
export var calculateVisibleItems = function calculateVisibleItems(items, size, containerSize) {
  var offset = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : -12;
  var widths = getWidths(items.length + 1, size, offset);
  var copy = _toConsumableArray(items);
  var checkItemVisible = function checkItemVisible(index) {
    if (!widths[index] || index === 0) {
      return;
    }
    var elementsSize = calcElementsVisibleSize(widths, copy);
    if (elementsSize > containerSize) {
      copy.pop();
    }
  };
  for (var index = items.length; index > 0; index -= 1) {
    checkItemVisible(index);
  }
  if (copy.length !== items.length) {
    copy.pop();
  }
  return copy;
};